import { FC } from 'react'
import { Icon } from '@iconify/react'
import clsx from 'clsx'

import s from './GoogleConnectionStatus.module.css'

type Props = {
  title: string
  description: string
  hasAutoMatched: boolean
  hasManuallyMatched: boolean
  isGscSelected: boolean
}

export const GoogleConnectionStatus: FC<Props> = ({
  title,
  description,
  hasAutoMatched,
  hasManuallyMatched,
  isGscSelected,
}) => {
  return (
    <div
      className={clsx(s.wrapper, {
        [s.isSuccess]: hasAutoMatched || hasManuallyMatched,
      })}
    >
      <div>
        <div className={s.header}>
          {hasAutoMatched || hasManuallyMatched ? (
            <Icon icon="uil:check-circle" className={s.icon} width={24} />
          ) : (
            <Icon icon="lucide:alert-triangle" className={s.icon} width={24} />
          )}
          {title}
        </div>
        <div className={s.subHeader}>{description}</div>
      </div>

      <div className={s.features}>
        <span className={s.feature}>
          <Icon
            className={clsx(s.icon, s.green)}
            icon="lucide:check-circle"
            width={16}
          />
          Idea Lab
        </span>
        <span className={s.feature}>
          {hasAutoMatched || hasManuallyMatched || isGscSelected ? (
            <Icon
              className={clsx(s.icon, { [s.green]: isGscSelected })}
              icon="lucide:check-circle"
              width={16}
            />
          ) : (
            <Icon icon="uil:lock-alt" className={s.icon} width={16} />
          )}
          Website Content Audit
        </span>
        <span className={s.feature}>
          {hasAutoMatched || hasManuallyMatched ? (
            <Icon className={s.icon} icon="lucide:check-circle" width={16} />
          ) : (
            <Icon icon="uil:lock-alt" className={s.icon} width={16} />
          )}
          Analytics & ROI
        </span>
      </div>
    </div>
  )
}
